import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthHooks';
import RecoverPassword from './RecoverPassword';
import AccountConfirm from './AccountConfirm';
import Login from './Login';

interface AuthProps{
	
}

var Auth = (props: AuthProps)=>{
	var { t } = useTranslation();
	var { params } = useAuth();

	if(params.recover_token) return <RecoverPassword />
	if(params.confirm_token) return <AccountConfirm />

	return <Login />
}

export default Auth;